// extracted by mini-css-extract-plugin
module.exports = {"container":"MLoading_container__uWeBP","spinner":"MLoading_spinner__2RFXq","percent":"MLoading_percent__2u_Xj"};